import React, { useState, useEffect } from "react";
import Text from "../../../../../../../_components/Text";
import LoadingInput from "../../../../../../../_components/LoadingInput";

import { CreateNFeContext } from "../../../Context";

export default (props) => {
  const context = React.useContext(CreateNFeContext);
  const [sendDate, setSendDate] = React.useState(new Date());
  const [updateDate, setUpdateDate] = React.useState(new Date());
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentDateTime());

  function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  function onChangeSendDate(e) {
    const value = e.target.value
    if (!value) return
    setCurrentDateTime(value)
    setSendDate(value)
    const { nfe } = context
    nfe.identification.send_date = value;
    context.handlers.updateNFeData(nfe);
  }
  
  function onChangeUpdateDate(e) {
    const value = e.target.value
    if (!value) return
    setCurrentDateTime(value)
    setUpdateDate(value)
    const { nfe } = context
    nfe.identification.update_date = value;
    context.handlers.updateNFeData(nfe);
  }

  useEffect(() => {
    const { nfe } = context;
    if (props.dateType === "sendDate" && !nfe.identification.send_date) {
      nfe.identification.send_date = currentDateTime;
      context.handlers.updateNFeData(nfe);
    } else if (props.dateType === "updateDate" && !nfe.identification.update_date) {
      nfe.identification.update_date = currentDateTime;
      context.handlers.updateNFeData(nfe);
    }

    const intervalId = setInterval(() => {
      const now = getCurrentDateTime();
      setCurrentDateTime(now);
      
      const { nfe: currentNfe } = context;
      if (props.dateType === "sendDate" && currentNfe.identification.send_date === currentDateTime) {
        currentNfe.identification.send_date = now;
        context.handlers.updateNFeData(currentNfe);
      } else if (props.dateType === "updateDate" && currentNfe.identification.update_date === currentDateTime) {
        currentNfe.identification.update_date = now;
        context.handlers.updateNFeData(currentNfe);
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [currentDateTime, props.dateType]);

  return (
    props.dateType == "sendDate" ? 
      <div className="">
        <Text color="primary">Data de emissão da NF-e</Text>
        <LoadingInput required onChange={onChangeSendDate} value={currentDateTime} type="datetime-local" />
      </div>
    :
      <div className="">
        <Text color="primary">Data de saída da NF-e</Text>
        <LoadingInput required onChange={onChangeUpdateDate} value={currentDateTime} type="datetime-local" />
      </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/SendDate/index.jsx